"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "required-calendar" };
const _hoisted_2 = { class: "role-calendar-wrapper" };
const _hoisted_3 = { class: "weekdays-row" };
const _hoisted_4 = { class: "role-calendar-container" };
const _hoisted_5 = { class: "date-num" };
const vue_3 = require("vue");
const common_1 = require("../common/common");
const dateInt_1 = __importDefault(require("../common/dateInt"));
const japanesePublicHolidays_1 = __importDefault(require("../common/japanesePublicHolidays"));
const timeZones_1 = __importDefault(require("../common/timeZones"));
const dateIntToKanji_1 = require("../common/dateIntToKanji");
const RoleRequiredCalendarCell_vue_1 = __importDefault(require("./RoleRequiredCalendarCell.vue"));
const RequiredCalendarNav_vue_1 = __importDefault(require("../roleSectionTemplate/components/RequiredCalendarNav.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredCalendar',
    setup(__props) {
        const requiredDataMap = (0, vue_3.inject)("roleRequiredMap");
        const selectedDate = (0, vue_3.ref)(new Date());
        function handleSelectedDate(emittedDate) {
            selectedDate.value = emittedDate;
        }
        function handleEmitCell(requiredData) {
            if (!requiredData.realDate || !requiredDataMap) {
                return;
            }
            const date = (0, common_1.yearMonthDateString)(requiredData.realDate, timeZones_1.default.ASIA_TOKYO);
            if (requiredData.required === undefined) {
                delete requiredDataMap.value[date];
                return;
            }
            requiredDataMap.value[date] = {
                required: requiredData.required,
                realDate: requiredData.realDate,
            };
        }
        const weekDaysIndex = (0, vue_3.computed)(() => {
            const keyNums = Object.keys(dateIntToKanji_1.intToJapaneseWeekdayKanji);
            const weekDayObj = [];
            keyNums.forEach((n) => {
                const text = dateIntToKanji_1.intToJapaneseWeekdayKanji[parseInt(n)];
                if (text === undefined)
                    return;
                let styleClass = '';
                if (n == String(dateInt_1.default.SUN)) {
                    styleClass = 'th-holiday';
                }
                else if (n == String(dateInt_1.default.SAT)) {
                    styleClass = 'th-saturday';
                }
                weekDayObj.push({ text, styleClass });
            });
            return weekDayObj;
        });
        // Computed value to get the selected month
        const selectedMonth = (0, vue_3.computed)(() => {
            return selectedDate.value.getMonth();
        });
        // Computed value to get the selected year
        const selectedYear = (0, vue_3.computed)(() => {
            return selectedDate.value.getFullYear();
        });
        const todayDateStr = (0, vue_3.computed)(() => {
            return (0, common_1.yearMonthDateString)(new Date(), timeZones_1.default.ASIA_TOKYO);
        });
        const calendarDates = (0, vue_3.computed)(() => {
            const dates = [];
            const date = new Date(selectedYear.value, selectedMonth.value);
            const firstDayOfWeek = date.getDay();
            for (let i = 0; i < firstDayOfWeek; i++) {
                dates.push({
                    dateStr: '',
                    styleClass: 'empty-cell',
                    isEmpty: true,
                    isHoliday: false,
                    weekDayIndex: 0
                });
            }
            while (date.getMonth() === selectedMonth.value) {
                const dateStr = (0, common_1.yearMonthDateString)(date, timeZones_1.default.ASIA_TOKYO);
                const realDate = new Date(date);
                const isDateHoliday = Boolean(japanesePublicHolidays_1.default[dateStr]);
                const isSaturday = date.getDay() === dateInt_1.default.SAT;
                const isSunday = date.getDay() === dateInt_1.default.SUN;
                const isToday = todayDateStr.value === dateStr;
                const dateObj = {
                    dateStr: dateStr,
                    weekDayIndex: date.getDay(),
                    date: date.getDate(),
                    realDate: new Date(realDate),
                    styleClass: '',
                    isEmpty: false,
                    isHoliday: isDateHoliday,
                };
                if (isSaturday) {
                    dateObj.styleClass = 'th-saturday';
                }
                if (isDateHoliday || isSunday) {
                    dateObj.styleClass = 'th-holiday';
                }
                if (isToday) {
                    dateObj.styleClass = 'today-text-num';
                }
                dates.push(dateObj);
                date.setDate(date.getDate() + 1); // Move to the next day
            }
            const remainingDaysInWeek = (-dates.length % 7 + 7) % 7;
            for (let i = 0; i < remainingDaysInWeek; i++) {
                dates.push({
                    dateStr: '',
                    styleClass: 'empty-cell',
                    isEmpty: true,
                    isHoliday: false,
                    weekDayIndex: 0
                });
            }
            return dates;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("span", { class: "pb-10" }, "月ごとに設定", -1 /* CACHED */)),
                (0, vue_2.createVNode)(RequiredCalendarNav_vue_1.default, {
                    onEmitSelectedDate: handleSelectedDate,
                    "selected-date": selectedDate.value
                }, null, 8 /* PROPS */, ["selected-date"]),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createCommentVNode)(" Monthly "),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDaysIndex.value, (weekDay) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: (0, vue_2.normalizeClass)(weekDay.styleClass)
                            }, (0, vue_2.toDisplayString)(weekDay.text), 3 /* TEXT, CLASS */));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(calendarDates.value, (date, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: (0, vue_2.normalizeClass)(["calendar-cell", date.styleClass]),
                                key: `${date.dateStr}-${index}`,
                                tabindex: "0"
                            }, [
                                (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(date.date), 1 /* TEXT */),
                                (!date.isEmpty)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleRequiredCalendarCell_vue_1.default, {
                                        key: 0,
                                        "date-data": date,
                                        onEmitCell: handleEmitCell
                                    }, null, 8 /* PROPS */, ["date-data"]))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ], 2 /* CLASS */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
